import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Dialog, DialogContent, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';
import { Smartphone } from 'lucide-react';
import HomeScreenInstructions from './HomeScreenInstructions';

const SESSION_KEY = 'bob_welcome_shown';
const DISMISS_KEY = 'bob_welcome_dismissed';
const WINDOW_DAYS = 3;

export const WelcomeTip = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user?.created_at) return;
    if (localStorage.getItem(DISMISS_KEY) === 'true') return;
    if (sessionStorage.getItem(SESSION_KEY) === 'true') return;

    const created = new Date(user.created_at).getTime();
    if (Number.isNaN(created)) return;
    const daysSince = (Date.now() - created) / (1000 * 60 * 60 * 24);
    if (daysSince >= 0 && daysSince < WINDOW_DAYS) {
      const t = setTimeout(() => setOpen(true), 700);
      return () => clearTimeout(t);
    }
  }, [user]);

  const close = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setOpen(false);
  };
  const dontShowAgain = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) close(); }}>
      <DialogContent className="max-w-md" data-testid="welcome-tip-dialog">
        <div className="text-center space-y-4 py-2">
          <div className="mx-auto w-16 h-16 rounded-2xl bg-violet-100 dark:bg-violet-900/30 flex items-center justify-center">
            <Smartphone className="w-8 h-8 text-violet-600 dark:text-violet-400" />
          </div>
          <div>
            <DialogTitle className="text-xl font-outfit font-bold text-violet-600 dark:text-violet-400">
              Use Business Bestie anywhere
            </DialogTitle>
            <p className="text-sm text-muted-foreground mt-2">
              Business Bestie is a <b>web-based app</b>, so you can use it on any device — your phone, tablet, or computer — just by opening your link. Nothing to download!
            </p>
          </div>

          <HomeScreenInstructions />

          <div className="space-y-2">
            <Button className="w-full bg-violet-600 hover:bg-violet-700" onClick={close} data-testid="welcome-tip-got-it">
              Got it!
            </Button>
            <button
              type="button"
              onClick={dontShowAgain}
              className="text-xs text-muted-foreground hover:text-foreground underline"
              data-testid="welcome-tip-dismiss"
            >
              Don't show this again
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeTip;
